import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'

import { Close } from './Svg'

// Добавляем компонент уведомления об ошибке из предоставленного кода
const ErrorNotification = ({ message, onClose, visible }) => {
  if (!visible) return null;

  return (
    <div className="fixed top-4 right-4 z-50 max-w-sm">
      <div className="bg-white rounded-lg shadow-lg border border-red-100 p-4 flex items-start gap-3">
        <div className="w-5 h-5 rounded-full bg-red-500 flex items-center justify-center flex-shrink-0 mt-0.5">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z" stroke="white" strokeWidth="0.5"/>
            <path d="M6 4V6.5" stroke="white" strokeWidth="0.5" strokeLinecap="round"/>
            <path d="M6 8H6.005" stroke="white" strokeWidth="0.5" strokeLinecap="round"/>
          </svg>
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-900 mb-1">Ошибка</p>
          <p className="text-sm text-gray-600">{message}</p>
        </div>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600 transition-colors"
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 13L13 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M13 13L1 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

ErrorNotification.propTypes = {
  message: PropTypes.string,
  onClose: PropTypes.func,
  visible: PropTypes.bool
};

ErrorNotification.defaultProps = {
  message: 'Произошла ошибка',
  visible: false
};

// Добавляем компонент уведомления об успехе
const SuccessNotification = ({ message, onClose, visible }) => {
  if (!visible) return null;

  return (
    <div className="fixed top-4 right-4 z-50 max-w-sm">
      <div className="bg-white rounded-lg shadow-lg border border-green-100 p-4 flex items-start gap-3">
        <div className="w-5 h-5 rounded-full bg-green-500 flex items-center justify-center flex-shrink-0 mt-0.5">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 3L4.5 8.5L2 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-900 mb-1">Успешно</p>
          <p className="text-sm text-gray-600">{message}</p>
        </div>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600 transition-colors"
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 13L13 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M13 13L1 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

SuccessNotification.propTypes = {
  message: PropTypes.string,
  onClose: PropTypes.func,
  visible: PropTypes.bool
};

SuccessNotification.defaultProps = {
  message: 'Операция выполнена успешно',
  visible: false
};

const Pconf = () => (
  <svg className='flex-none' xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
    <circle cx={8} cy={8} r={8} fill="#5A91FF" fillOpacity={0.5} />
    <circle cx={8} cy={8} r={5} fill="#5A91FF" />
  </svg>
)

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      name: '',
      phone: '',
      text: ``,
      loading: false,
      errorNotification: {
        visible: false,
        message: ''
      },
      successNotification: {
        visible: false,
        message: ''
      }
    }
  }

  changeName(name) {
    this.setState({
      name: name
    })
  }

  changePhone(phone) {
    this.setState({
      phone: phone
    })
  }

  changeText(text) {
    this.setState({
      text: text
    })
  }

  showErrorNotification = (message) => {
    this.setState({
      errorNotification: {
        visible: true,
        message: message || 'Произошла ошибка'
      }
    });

    // Автоматическое скрытие через 5 секунд
    setTimeout(() => {
      this.hideErrorNotification();
    }, 5000);
  };

  hideErrorNotification = () => {
    this.setState({
      errorNotification: {
        visible: false,
        message: ''
      }
    });
  };

  showSuccessNotification = (message) => {
    this.setState({
      successNotification: {
        visible: true,
        message: message || 'Сообщение отправлено успешно'
      }
    });

    // Автоматическое скрытие через 5 секунд
    setTimeout(() => {
      this.hideSuccessNotification();
    }, 5000);
  };

  hideSuccessNotification = () => {
    this.setState({
      successNotification: {
        visible: false,
        message: ''
      }
    });
  };

  sendFeedback() {
    const main = this;
    const { name, phone, text } = this.state;

    // Проверка на пустые поля
    if (!name.trim()) {
      this.showErrorNotification('Пожалуйста, введите ваше имя');
      return;
    }

    if (!phone.trim()) {
      this.showErrorNotification('Пожалуйста, введите ваш телефон');
      return;
    }

    if (!text.trim()) {
      this.showErrorNotification('Пожалуйста, опишите ваш вопрос');
      return;
    }

    this.setState({
      loading: true
    }, () => {
      axios.post(`https://${window.location.host}`, {
        content_type: 'application/json',
        action: 'feedback_form',
        name: name.trim(),
        phone: phone.trim(),
        text: text.trim()
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Request-Source': 'Node.js'
        }
      }).then((response) => {
        main.setState({
          name: '',
          phone: '',
          text: ``,
          loading: false
        }, () => {
          main.showSuccessNotification('Ваше сообщение успешно отправлено! Мы свяжемся с вами в ближайшее время.');
          // Закрываем модальное окно через 2 секунды после успешной отправки
          setTimeout(() => {
            main.props.close();
          }, 2000);
        });
      })
      .catch((error) => {
        main.setState({
          loading: false
        });

        let errorMessage = 'Произошла ошибка при отправке сообщения';
        
        if (error.response) {
          // Сервер ответил с кодом ошибки
          errorMessage = error.response.data?.message || errorMessage;
        } else if (error.request) {
          // Запрос был сделан, но ответ не получен
          errorMessage = 'Не удалось подключиться к серверу';
        }
        
        main.showErrorNotification(errorMessage);
        console.error('Ошибка запроса:', error);
      });
    });
  }

  render() {
    const { show, close, assets_path } = this.props;
    const { name, phone, text, loading, errorNotification, successNotification } = this.state;

    return (
      <>
        <div class={`bg-[#00000066] backdrop-blur-[51.4px] z-[60] fixed top-0 w-[100%] h-dvh transition-all duration-300 ease-in-out ${show ? ` left-0` : ` left-[-100%]`}`}>
          <div className='container h-dvh flex flex-col tracking-tight px-[20px]'>
            <div className="flex justify-between items-center mt-[20px]">
              <button 
                onClick={() => close()}
                className="w-[40px] h-[40px] rounded-full bg-[#F6F6F6] flex items-center justify-center flex-none text-black"
                disabled={loading}
              >
                <Close />
              </button>
              <div></div>
            </div>
            <div className='flex flex-1 items-center justify-center flex-col mb-[60px] px-[10px]'>
              <div className='text-white text-center text-[22px] mb-[3px]'>Возникли вопросы?</div>
              <div className='text-[#FFFFFF99] text-center text-[14px] mb-[19px]'>
                Задайте нам вопрос. Менеджер свяжется <br />
                с вами и проконсультирует по всем деталям
              </div>
              
              {/* Поле для имени */}
              <input
                type="text"
                name="name"
                placeholder="Ваше имя"
                value={name}
                onChange={(e) => this.changeName(e.target.value)}
                className='text-[#00000099] text-[16px] p-[10px] rounded-[20px] bg-[#F6F6F6] border-[#F6F6F6] mb-[10px] h-[38px] w-[100%]'
                disabled={loading}
              />
              
              {/* Поле для телефона */}
              <input
                type="tel"
                name="phone"
                placeholder="Ваш телефон"
                value={phone}
                onChange={(e) => this.changePhone(e.target.value)}
                className='text-[#00000099] text-[16px] p-[10px] rounded-[20px] bg-[#F6F6F6] border-[#F6F6F6] mb-[10px] h-[38px] w-[100%]'
                disabled={loading}
              />
              
              <textarea
                name="text"
                placeholder="Опишите ваш вопрос"
                value={text}
                onChange={(e) => this.changeText(e.target.value)}
                className='text-[#00000099] pl-[33px] text-[16px] p-[10px] rounded-[20px] bg-[#F6F6F6] border-[#F6F6F6] mb-[10px] h-[86px] w-[100%]'
                disabled={loading}
                style={{
                  backgroundImage: `url(/${assets_path}/images/messages.svg)`,
                  backgroundPosition: `10px 10px`,
                  backgroundRepeat: `no-repeat`
                }}
              />
              <button
                onClick={() => this.sendFeedback()}
                disabled={loading || !name.trim() || !phone.trim() || !text.trim()}
                className='text-white text-[16px] cursor-pointer flex items-center justify-center h-[38px] w-[100%] bg-[#5A91FF] rounded-full mb-[10px] disabled:opacity-50 disabled:cursor-not-allowed'
              >
                {loading ? 'Отправка...' : 'Отправить'}
              </button>
              <div className='flex gap-[6px] cursor-pointer'>
                <Pconf />
                <div className='text-[#FFFFFF99] text-[12px]'>Нажимая на кнопку "Отправить", вы соглашаетесь с <a className='text-[#FFFFFF99] no-underline' href='/politika'>политикой конфиденциальности</a></div>
              </div>
            </div>
          </div>
        </div>

        {/* Уведомления */}
        <ErrorNotification
          visible={errorNotification.visible}
          message={errorNotification.message}
          onClose={this.hideErrorNotification}
        />
        
        <SuccessNotification
          visible={successNotification.visible}
          message={successNotification.message}
          onClose={this.hideSuccessNotification}
        />
      </>
    )
  }
}

Main.propTypes = {
  show: PropTypes.bool,
  close: PropTypes.func,
  assets_path: PropTypes.string
}

export default Main